<ui-modal
  class="treasury-curves-modal"
  [isOpened]="showTreasuryCurves"
  modalTitle="Treasury Curves"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="treasury-curves">
    <div class="treasury-curves__tables-container">
      <div class="treasury-curves__table-info-group-container">
        <div class="treasury-curves__table-info">
          <form [formGroup]="treasuryCurvesForm">
            <div #divToScrollCurves class="table-container">
              <table ui-table>
                <thead>
                  <tr>
                    <th class="entity">Entity</th>
                    <th class="currency">Currency</th>
                    <th class="day-count-convention">Day Count Convention</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container formArrayName="curves">
                    <tr
                      tabindex="0"
                      *ngFor="let item of curvesArray.controls; let i = index"
                      (click)="
                        selectedCurveIndex = i; selectedTenorIndex = null
                      "
                      [ngClass]="{ 'selected-row': selectedCurveIndex === i }"
                    >
                      <ng-container [formGroupName]="i">
                        <td class="pad">
                          <select formControlName="entity">
                            <option
                              *ngFor="let item of identifiers"
                              [value]="item"
                            >
                              {{ item }}
                            </option>
                          </select>
                        </td>

                        <td class="pad">
                          <input
                            type="text"
                            class="input-cell"
                            formControlName="currency"
                            [inputValidator]="['currency']"
                            spellcheck="false"
                          />
                        </td>

                        <td class="pad">
                          <select formControlName="dayCountConvention">
                            <option value="Act/360">Act/360</option>
                            <option value="Act/365">Act/365</option>
                          </select>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </form>
          <div class="bottom-table-add">
            <div *ngIf="!loadingCurves; else EntitiesLoading">
              <span class="add-text-container"
                ><label class="add-text-container__add">+</label>
                <label
                  class="add-text-container__add-text"
                  (click)="addNewCurve()"
                  >Add Treasury Curve</label
                ></span
              >
            </div>
            <ng-template #EntitiesLoading>
              <span class="add-text-container">
                <label
                  class="
                    add-text-container__add-text add-text-container__loading
                  "
                  >Loading</label
                ></span
              >
            </ng-template>
          </div>
        </div>
        <div class="treasury-curves__table-tenor__footer">
          <button
            class="
              ui-button ui-button__header ui-button--danger ui-button--delete
            "
            [disabled]="selectedCurveIndex === null"
            (click)="deleteCurve()"
          >
            Delete Curve
          </button>
        </div>
      </div>

      <div class="treasury-curves__table-tenor__group-container">
        <div class="treasury-curves__table-tenor">
          <form [formGroup]="treasuryCurvesForm">
            <div #divToScrollTenor class="table-container">
              <table ui-table>
                <thead>
                  <tr>
                    <th class="tenor">
                      <ng-container *ngIf="dateMode === 'DATE'">
                        Date
                      </ng-container>
                      <ng-container *ngIf="dateMode === 'TENOR'">
                        Tenor
                      </ng-container>
                    </th>
                    <th class="bid">Bid</th>
                    <th class="ask">Ask</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container
                    *ngIf="this.selectedCurveIndex !== null"
                    formArrayName="curves"
                  >
                    <ng-container [formGroupName]="selectedCurveIndex">
                      <tr
                        tabindex="0"
                        *ngFor="
                          let item of tenorAskBidArray('tenors')?.controls ||
                            tenorAskBidArray('dates')?.controls;
                          let i = index
                        "
                        (click)="selectedTenorIndex = i"
                        [ngClass]="{ 'selected-row': selectedTenorIndex === i }"
                      >
                        <ng-container
                          formArrayName="tenors"
                          *ngIf="dateMode === 'TENOR'"
                        >
                          <td class="pad">
                            <input
                              type="text"
                              class="input-cell"
                              [formControlName]="i"
                              [placeholder]="'#' + (i + 1)"
                              [inputValidator]="['tenor']"
                              spellcheck="false"
                            />
                          </td>
                        </ng-container>
                        <ng-container
                          formArrayName="dates"
                          *ngIf="dateMode === 'DATE'"
                        >
                          <td class="pad">
                            <input
                              type="text"
                              class="input-cell"
                              [formControlName]="i"
                              [placeholder]="'#' + (i + 1)"
                              [inputValidator]="['dateShorthand']"
                              spellcheck="false"
                            />
                          </td>
                        </ng-container>

                        <ng-container formArrayName="bidRates">
                          <td class="pad">
                            <input
                              type="text"
                              class="input-cell"
                              [formControlName]="i"
                              (click)="
                                textBoxCaretRestrictionHandler($event, 'click')
                              "
                              (keydown)="
                                textBoxCaretRestrictionHandler(
                                  $event,
                                  'keydown'
                                )
                              "
                              (focus)="selectedPercentField = $event.target"
                              [inputValidator]="['percentageAllowNegatives']"
                              spellcheck="false"
                            />
                          </td>
                        </ng-container>

                        <ng-container formArrayName="askRates">
                          <td class="pad">
                            <input
                              type="text"
                              class="input-cell"
                              [formControlName]="i"
                              (click)="
                                textBoxCaretRestrictionHandler($event, 'click')
                              "
                              (keydown)="
                                textBoxCaretRestrictionHandler(
                                  $event,
                                  'keydown'
                                )
                              "
                              (focus)="selectedPercentField = $event.target"
                              [inputValidator]="['percentageAllowNegatives']"
                              spellcheck="false"
                            />
                          </td>
                        </ng-container>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </form>
          <div class="bottom-table-add">
            <div>
              <span
                class="add-text-container"
                [ngClass]="{ disabled: selectedCurveIndex === null }"
                ><label class="add-text-container__add">+</label>
                <label
                  class="add-text-container__add-text"
                  (click)="addNewDateOrTenor(dateMode)"
                >
                  <ng-container *ngIf="dateMode === 'TENOR'">
                    Add Tenor
                  </ng-container>
                  <ng-container *ngIf="dateMode === 'DATE'">
                    Add Date
                  </ng-container>
                </label>
              </span>
            </div>
          </div>
        </div>
        <div class="treasury-curves__table-tenor__footer">
          <button
            class="
              ui-button ui-button__header ui-button--danger ui-button--delete
            "
            [disabled]="selectedTenorIndex === null"
            (click)="deleteDateOrTenor(dateMode)"
          >
            <ng-container *ngIf="dateMode === 'TENOR'">
              Delete Tenor
            </ng-container>
            <ng-container *ngIf="dateMode === 'DATE'">
              Delete Date
            </ng-container>
          </button>
        </div>
      </div>
    </div>

    <div class="treasury-curves__footer">
      <button
        class="ui-button primary"
        [disabled]="!allowedToSave"
        (click)="saveChanges()"
      >
        <ng-container [ngSwitch]="savingCurvesStatus">
          <span *ngSwitchCase="''"> Save </span>
          <span
            *ngSwitchCase="'LOADING'"
            class="spinner spinner-sm spinner-inverse"
          >
          </span>
          <span *ngSwitchCase="'DONE'"> Saved </span>
          <span *ngSwitchCase="'ERROR'"> Error </span>
        </ng-container>
      </button>
    </div>
  </div>
</ui-modal>
